import React, { useEffect, useState } from "react";
import { Row, Col, Form, Table, Container, Button, FormGroup, Alert, Tab, Tabs } from "react-bootstrap";

import { ModalBody,Modal} from "reactstrap";

import { connect } from "react-redux";
import { isEmpty, find, isUndefined } from "lodash";
import Spinner from 'react-bootstrap/Spinner';
import MaterialTable from 'material-table';
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { IconButton } from "@material-ui/core";
import Select from 'react-select';
import Swal from 'sweetalert';
import { getIssuance } from "./Issuance.action";

const IssuanceDetail = (props) => {

    const wareHouseData = props.IssuanceList;
   /* const [state, setState] = React.useState({
        viewColumns: [
            { title: 'Issuance Number', field: 'issuanceId' },
            { title: 'Requistion', field: 'requsition' },
            { title: 'Department', field: 'department' },
            { title: 'Production Order', field: 'productionOrder' },
            { title: 'Supervisor', field: 'supervisor' },
            { title: 'Issued By', field: 'issuedBy' },
            { title: 'Received By', field: 'receivedBy' },
            { title: 'Requistion Type', field: 'requsitionType' },
        ],
        columnsData: [
            { title: 'Inventory Code', field: 'inventory', render: rowData => rowData.inventory.warehouse.whKey + "-" + rowData.inventory.category.cateKey + "-" + rowData.inventory.sub_category.subcateKey + "-" + rowData.inventory.invKey },
            { title: 'Inventory Name', field: 'inventory.productName' },
            { title: 'Product Quantity', field: 'productQuantity' },
        ],
    });*/
    useEffect(() => {
        props.getIssuance();
    }, []);
    return (
        <>
                    {props.isFetchingIssuance ? (
                        <div className="loader-div">
                            <Button variant="info" disabled>
                                <Spinner
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    variant="info"
                                />
                                {/* {props.isFetchingSectorsSummary ? 'Loading...' : 'Loading...'} */}

                            </Button>
                        </div>
                    ) : (
                        <Container fluid>
                            <div className="main">
                                <MaterialTable
                                    title="Issuance Details"
                                    columns={[
                                        { title: 'Issuance Date', field: 'issuanceDate' },
                                        // { title: 'Requistion', field: 'requsition' },
                                        { title: 'Department', field: 'department.department' },
                                        // { title: 'Production Order', field: 'productionOrder' },
                                        { title: 'Supervisor', field: 'supervisor' },
                                        { title: 'Issued By', field: 'issuedBy' },
                                        { title: 'Received By', field: 'receivedBy' },
                                        // { title: 'Requistion Type', field: 'requsitionType' },
                                    ]}
                                    data={wareHouseData}
                                    detailPanel={rowData => {
                                        return (
                                            <MaterialTable
                                                columns={[
                                                    { title: 'Product Code', field: 'inventoryId.code', 
                                                    // render: rowData => rowData.inventory.warehouse.whKey + "-" + rowData.inventory.category.cateKey + "-" + rowData.inventory.sub_category.subcateKey + "-" + rowData.inventory.invKey 
                                                },
                                                    { title: 'Product Name', field: 'inventoryLabel' },
                                                    { title: 'Issuance Quantity', field: 'issuanceQuantity' },
                                                ]}
                                                data={rowData.data}
                                                options={{
                                                    actionsColumnIndex: -1,
                                                    toolbar: false,
                                                    exportButton: true,
                                                    sorting: true,
                                                    paging:true,
                                                    pageSize:50,       // make initial page size
                                                    emptyRowsWhenPaging: false,   // To avoid of having empty rows
                                                    pageSizeOptions:[30,50,100,150,200],    // rows selection options
                                                    headerStyle: {
                                                        position: 'sticky', top: 0,
                                                        color: '#00BBBB',
                                                        fontWeight: '550',
                                                        onRowAdd: 'none',
                                                    }
                                                }}

                                            />
                                        )
                                    }}
                                    options={{
                                        actionsColumnIndex: -1,
                                        filtering: true,
                                        exportButton: true,
                                        paging:true,
                                        pageSize:50,       // make initial page size
                                        emptyRowsWhenPaging: false,   // To avoid of having empty rows
                                        pageSizeOptions:[30, 50,100,150,200], 
                                        headerStyle: {
                                            position: 'sticky', top: 0,
                                            color: '#00BBBB',
                                            fontWeight: '550',
                                            onRowAdd: 'none',
                                        }
                                    }}
                                    onRowClick={(event, rowData, togglePanel) => togglePanel()}
                                />
                            </div>
                        </Container>
                    )}
              
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {

        getIssuance: () => dispatch(getIssuance()),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingIssuance:state.IssuanceReducer.isFetchingIssuance,
    IssuanceList:state.IssuanceReducer.IssuanceList
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IssuanceDetail);